import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Col from 'component/utils/Col'
import Form from 'component/utils/Form'
import Field from 'component/utils/Field'
import CompanySelect from 'component/branch/CompanySelect'

class BranchFilterLmExpress extends Component {
  static propTypes = {
    translate: PropTypes.func.isRequired,
    fetchLmExpress: PropTypes.func.isRequired,
    setValueToField: PropTypes.func.isRequired,
    values: PropTypes.object.isRequired,
    auth: PropTypes.object.isRequired,
    fields: PropTypes.object.isRequired,
  }

  handleFetchLmExpress = (event) => {
    event.preventDefault()

    const { fetchLmExpress, values } = this.props

    fetchLmExpress(values)
  }

  handleChangeBranch = (event) => {
    const field = this.props.fields
    field.idBranch.input.onChange(event)
  }

  render() {
    const { translate } = this.props
    const field = this.props.fields

    return (
      <form
        onSubmit={this.handleFetchLmExpress}
        className='ruptures-page container-mobile'
      >
        <div className='margin-left-double margin-right-double center-select-date'>
          <Col xs={12} className='margin-bottom-double padding-bottom-double'>
            <Col xs={12} className='margin-bottom-small'>
              <h3 className='name color-text'>
                {translate('mobile.previousDayLmExpress')}
              </h3>
            </Col>

            <Col xs={12}>
              <span className='gray-label'>{translate('lmexpress.hint')}</span>
            </Col>

            <Col xs={12}>
              <Field
                {...field.idBranch}
                error={translate(field.idBranch.error)}
                hint={translate('lmexpress.idBranch')}
                icon='glyph glyph-clock'
              >
                <CompanySelect
                  {...field.idBranch.input}
                  onChange={this.handleChangeBranch}
                />
              </Field>
            </Col>

            <Col xs={12} sm={6} md={3} className='margin-top-one-point-seven'>
              <button
                type='submit'
                className='button button-primary button-full'
              >
                {translate('lmexpress.filter')}
              </button>
            </Col>
          </Col>
        </div>
      </form>
    )
  }
}

const fields = ['idBranch']

export default Form({ fields })(BranchFilterLmExpress)

export { BranchFilterLmExpress }
